/*
==========================================
Custom JS for Product page giftship elements
商品詳細 giftship カスタマイズ用JS
==========================================
*/

/**
 * giftshipのloaded判定
 * @type {boolean} gifshipLoaded
 */
let giftshipLoaded = false

/**
 * カートからクエリ付きで遷移した場合にギフト設定を表示
 * @param {'add'|'change'} view 追加 or 更新を文字列で受け取る
 * @param {URLSearchParams} params クエリパラメータ
 */
const changeView = (view, params) => {

  if (!view || (view !== 'add' && view !== 'change')) return

  // Line item の key
  const key = params.get('key')
  if (!key) return

  const qty = params.get('qty') || 1

  if (view === 'add') {
    handleModal(key, qty)
  } else if (view === 'change') {
    // 選択済みギフトのID
    const selected = params.get('selected')
    // paramを配列に格納
    const selectedIds = selected.split(',')

    // 「のし下」の記述内容
    const textFieldVal = params.get('text_field')

    // テキストコンテンツの内容
    handleModal(key, qty, selectedIds, textFieldVal)
  }
}

/**
 * モーダル表示制御
 * @param {string} key 更新する Line item の key
 * @param {string} qty 数量
 * @param {string[]?} selected 選択済みギフトのIDの配列
 * @param {string} textFieldVal のし下
 */
const handleModal = (key, qty, selected, textFieldVal) => {
  // giftship がロード済みかどうか
  if (giftshipLoaded) {
    setGifts(selected, textFieldVal)
  } else {
    document.addEventListener('giftship.loaded', function(){
      setTimeout(function(){
        document.querySelector('.js-product-gift-modal').classList.remove('is-loading')
        setGifts(selected, textFieldVal)
      }, 800)
    })
  }


  // 決定ボタンのイベントハンドラ
  const $giftSubmitBtn = document.querySelector('.js-product-gift-modal-submit')
  $giftSubmitBtn.addEventListener('click', function(){
    const props = createProperties()
    if (props) {
      updateCart(key, props, qty)
    } else {
      // エラー文言
      document.querySelector('.js-product-gift-modal-error').classList.add('is-active')
    }
  })
}

/**
 * モーダル内要素の表示制御
 * @param {string[]?} selected 選択済みギフトのIDの配列
 * @param {string | null} textFieldVal 「のし下」記述内容
 */
const setGifts = (selected, textFieldVal) => {
  console.log({selected, textFieldVal})
  // giftshipの要素をモーダルへ追加
  const $giftshipEl = document.getElementById('gsAppContainer')
  const $appContainer = document.getElementById('productGiftModalAppContainer')
  $appContainer.appendChild($giftshipEl)

  const $modalEl = document.querySelector('.js-product-gift-modal')

  // 選択済みのものを選択状態にする
  if (selected && selected.length) {
    const propInputs = $modalEl.querySelectorAll('input[name^=properties]')
    Array.from(propInputs).forEach(el => {
      if (selected.includes(el.value)) {
        el.parentElement.click()
      } else if (el.getAttribute('name') === 'properties[のし下]') {
        if (textFieldVal && textFieldVal !== '') {
          el.value = textFieldVal
        }
      }

    })
  }

  // 価格を修正（ドル→円）
  const priceElements = $modalEl.querySelectorAll('[data-gsmoney]')
  if (priceElements.length) {
    priceElements.forEach(el => {

      const gsPriceData = Number(el.dataset.gsmoney)
      el.textContent = `¥${gsPriceData}`
    })
  }

    // テキストインプットに注釈を追加
  const $textInput = $appContainer.querySelector('.gs__product-option[data-child-type="text"]')
  if ($textInput) {
    const noteContent = `<span>贈り主のお名前を連名で入れる場合には、3名様までとさせていただきます。<br>
    それ以上の場合は、ご一同様(例：有志一同、家族一同、総務課一同等)での記載をお願いいたします。<br><br>
      連名の場合には、お名前とお名前の間に／で区切りを入れてください。(例：鈴木／佐藤／高橋)<br>
      のし下にはご入力いただいた左側のお名前から順に縦書きで右から左の順に印字いたします。<br>
      (例：「鈴木／佐藤／高橋」とご入力いただいた場合、[右]鈴木 (改行) [中央]佐藤 (改行) [左]高橋の順に印字)<br></span>`
    $textInput.querySelector('label').insertAdjacentHTML('beforeend', noteContent)
  }

}

/**
 * プロパティを作成
 */
const createProperties = () => {

  const props = {
    _gs_bundle_contents: [],
    _gs_bundle_ids: [],
    _gs_bundle_prices: []
  }

  // バリデーションチェック
  let isValidated = true

  const $modalEl = document.querySelector('.js-product-gift-modal')

  const optionContainers = $modalEl.querySelectorAll('.gs__product-option')


  Array.from(optionContainers).forEach(el => {
    // エラーリセット
    el.classList.remove('is-custom-error')
    el.classList.remove('is-custom-text-error')
    document.querySelector('.js-product-gift-modal-error').classList.remove('is-active')

    // 非表示かどうか
    const isHidden = el.classList.contains('gs__hidden-option')

    // 必須フラグ
    let isRequired = false
        // テキストフィールドかどうか
    let isTextInput = false
    // バリデーションフラグ（処理中のブロック分）
    let isRowValidated = true

    // 処理中ブロックの値
    let bundleValidated = false
    let propValidated = false

    if (!isHidden) {
      propertyInputs = el.querySelectorAll('input[name^=_gs],input[name^=properties]')

      Array.from(propertyInputs).forEach(_el => {

        if (_el.required) { isRequired = true }

        if (_el.getAttribute('name').includes('_gs_bundle_ids') && _el.checked) {
          props._gs_bundle_contents.push(_el.dataset.childOptionName)
          props._gs_bundle_ids.push(_el.getAttribute('value'))
          props._gs_bundle_prices.push(_el.dataset.bundleCents)
          bundleValidated = true
        } else if (_el.getAttribute('type') !== 'checkbox') {
                    isTextInput = true

          const propertyName = _el.getAttribute('name').replace(/properties\[(.*)\]/, '$1')
          if (!isRequired) {
            propValidated = true
            props[propertyName] = _el.value && _el.value !== '' ? _el.value : null
          } else {
            if (_el.value && _el.value !== '') {
              propValidated = true
              props[propertyName] = _el.value && _el.value !== '' ? _el.value : null
            } else {
              props[propertyName] = null
            }
          }

          // 文字数チェック
          if (_el.value && _el.value.length > 30) {
            propValidated = false
            props[propertyName] = null
          }
        }
      })

      // 必須バリデーション
      if (isRequired) {
        if (
          !bundleValidated &&
          !propValidated
        ) {
          isRowValidated = false
        }
              } else if (isTextInput && !propValidated) {
        isRowValidated = false
        el.classList.add('is-custom-text-error')
      }

      if (!isRowValidated) {
        isValidated = false
        // エラー表示
        el.classList.add('is-custom-error')
      }

    }
  })


  if (isValidated) {
    return props
  } else {
    return false
  }

}

/**
 * プロパティを更新
 * @param {string} key Line item key
 * @param {any} props Line item properties
 * @param {string} qty 数量
 */
const updateCart = async (key, props, qty) => {

  const payload = {
    id: key,
    properties: props,
    quantity: Number(qty)
  }

  // giftship、のし下以外の既存プロパティがあれば取得してpayloadへマージ
  const exisitingProps = await checkExistingProps(key)

  if (exisitingProps) {
    payload.properties = {...props, ...exisitingProps}
  }


  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': "application/json"
    },
    body: JSON.stringify(payload)
  })
  .then(() => {
    location.href = '/cart'
  })
  .catch((e) => {
    console.error({e})
  })
}

/**
 * 特定のkey以外の既存プロパティがあれば返却
 * @param {string} key
 * @returns {any} 既存props
 */
const checkExistingProps = async (key) => {

  try {
    const cartInfo = await fetch('/cart.js')
    const cartInfoJson = await cartInfo.json()

    const currentLineItem = cartInfoJson.items.filter(item => {
      return item.key === key
    })

    if (
      !currentLineItem ||
      !currentLineItem.length
    ) return null


    const props = currentLineItem[0].properties

    if (!props || !Object.keys(props).length) return null

    const returnObj = {}

    Object.keys(props).forEach(key => {
      if (key !== 'のし下' && !key.includes('_gs')) {
        returnObj[key] = props[key]
      }
    })

    if (Object.keys(returnObj).length) {
      return returnObj
    }

    return null

  }
  catch {
    return null
  }

}


// イベントリスナー
document.addEventListener('giftship.loaded', function(){
  giftshipLoaded = true
  document.querySelector('.js-product-gift-modal').classList.remove('is-loading')
})

document.addEventListener('DOMContentLoaded', function(){
  const url = new URL(location.href)
  const params = url.searchParams

  // 表示切り替え用パラメータ取得
  const viewParam = params.get('view')

  if (!viewParam) return

  const $modalEl = document.querySelector('.js-product-gift-modal')
  $modalEl.classList.add('is-active', 'is-loading')

  // 背景スクロール防止
  document.body.style.overflow = 'hidden'

  changeView(viewParam, params)

})